// NATIVE
import { createRef, Fragment, useRef } from 'react';

// INSTALLED
import Draggable from 'react-draggable';
import Dialog from '@mui/material/Dialog';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DialogTitle from '@mui/material/DialogTitle';
import { PaperProps } from '@mui/material/Paper';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import {
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Box,
  Chip,
} from '@mui/material';

// CUSTOM
import { useSelector } from 'react-redux';
import { formatDateToYmd } from '../../../commons/utils';

// fuera del componente para mantener la referencia viva
const draggableRef: any = createRef<HTMLDivElement>();

const PaperComponent = (props: PaperProps) => {
  return (
    <Draggable
      nodeRef={draggableRef}
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper ref={draggableRef} {...props} />
    </Draggable>
  );
};

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export const PeriodoPrueba = (props: any) => {
  const { employePeriodoPruebaResumen } = useSelector((state: any) => state.employee);

  // PROPS
  const { open, handleCloseModal } = props;

  // CONST FUNCTIONS
  const handleClose = () => {
    handleCloseModal(false);
  };

  return (
    <Fragment>
      <Dialog
        onClose={handleClose}
        open={open}
        fullWidth={true}
        maxWidth={'md'}
        PaperComponent={PaperComponent}
      >
        <DialogTitle
          style={{ cursor: 'move' }}
          id="draggable-dialog-title"
          sx={{
            m: 0,
            p: 2,
            background: '#26e7a5',
            color: '#fff',
            display: 'flex',
            alignItems: 'center',
            gap: 1,
          }}
        >
          <span style={{ display: 'flex', alignItems: 'center' }}>
            <svg width="30" height="30" fill="none" viewBox="0 0 24 24" style={{ marginRight: 8 }}>
              <circle cx="12" cy="12" r="12" fill="#fff" opacity="0.15" />
              <path
                d="M12 12c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V20h14v-2.5c0-2.33-4.67-3.5-7-3.5z"
                fill="#fff"
              />
              <path d="M17.5 10.5l-2.5 2.5-1-1 1.5-1.5 1 1 2-2 1 1-2.5 2.5z" fill="#43a047" />
            </svg>
          </span>
          Empleados en periodo de prueba
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: '#fff',
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent dividers>
          <Grid container size={2}>
            <Grid size={12}>
              <TableContainer
                component={Paper}
                elevation={4}
                sx={{
                  borderRadius: 3,
                  overflow: 'hidden',
                }}
              >
                <Table>
                  <TableHead sx={{ backgroundColor: '#f4f6f8' }}>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 600 }}>Nombre</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Fecha Ingreso</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Fecha Fin Prueba</TableCell>
                      <TableCell sx={{ fontWeight: 600 }}>Días Restantes</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {employePeriodoPruebaResumen && employePeriodoPruebaResumen.length > 0 ? (
                      employePeriodoPruebaResumen.map((row: any, idx: number) => (
                        <TableRow
                          key={idx}
                          sx={{ backgroundColor: idx % 2 === 0 ? '#fcfcfc' : 'white' }}
                        >
                          <TableCell>{row.name}</TableCell>
                          <TableCell>{formatDateToYmd(row.startDate)}</TableCell>
                          <TableCell>{formatDateToYmd(row.endDate)}</TableCell>
                          <TableCell>
                            <Chip
                              label={`${row.daysRemaining} días`}
                              color={row.daysRemaining <= 5 ? 'error' : 'success'}
                              variant="outlined"
                              sx={{ fontWeight: 'bold' }}
                            />
                          </TableCell>
                        </TableRow>
                      ))
                    ) : (
                      <TableRow>
                        <TableCell colSpan={4}>
                          <Box p={3} textAlign="center">
                            <Typography variant="body1" color="text.secondary">
                              No hay tareas pendientes.
                            </Typography>
                          </Box>
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
    </Fragment>
  );
};
